import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import { InputInteger, InputRadio } from "../../components/ModelFormView";

import { GUTTER, COL_SIZE, COL_SIZE_PRICE } from '../../theme';


export default function Decoders({
    decoders,
    decoder,
    minRecorders,
    amount,
    formRef,
    onChange,
}) {
    const { t } = useTranslation('appxweb');

    if (decoders.length < 1) {
        return null;
    }

    return (
        <Row gutter={GUTTER}>
            <Col {...COL_SIZE}>
                <div className="col-cnt col-cnt-left">
                    <strong style={{marginRight: 10}}>
                        {t('SignUpRequest.decoders')}:
                    </strong>
                    <InputRadio
                        name="decoder"
                        options={decoders}
                        onChange={onChange}
                        initialValue={decoder}
                    />
                    <nobr>
                    <strong style={{marginRight: 15}}>
                        {t('SignUpRequest.decoders_number')}:
                    </strong>
                    <InputInteger
                        name="numOfDecoders"
                        onChange={onChange}
                        formRef={formRef}
                        initialValue={minRecorders}
                        min={minRecorders}
                        style={{
                            display: "inline-block",
                            width: 140,
                            margin: "13px 0 0",
                        }}
                    />
                    </nobr>
                </div>
            </Col>
            <Col {...COL_SIZE_PRICE}>
                <div className="col-cnt col-cnt-right">
                    {amount}
                </div>
            </Col>
        </Row>
    );
}
